const mod = require('humps')

module.exports = mod
